'use strict';

module.exports = {
  GET_EXPIRING_STARS: 'get-expiring-stars',
};
